// extracted by mini-css-extract-plugin
module.exports = {"coincidencesList":"style_coincidencesList__3zpGG","button":"style_button__1OfqM"};